<template>
  <div class="slide">
    <div class="a" :class="{ 'act': curs < 0 }" @click='setDateTime'>
      <span>首页</span>
      <div class="Slider"></div>
    </div>
    <div v-for='(i, index) in slide' :key='index' class="a"
      :class="{ 'act': (curs == i.cur || cursQg(curs)[0] == cursQg(i.cur)[0]) && curs != '3-1' }" @click="FlinkTo(i)">
      <span>{{ i.title }}</span>
      <div class="Slider"></div>
    </div>
  </div>
</template>
<script>
import Slide from "./slide_n"
import User1 from "./user1"
import store from "../../store/index";
function putSlide(menu, userId) {
  const baseMenu = [{
    title: '法院目录',
    link: 'directoryManage',
    key: 'court:list',
    other: true,
    icon: 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/mulv.png',
    icon1: 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/mulv1.png',
    cur: '3-0',
  }]
  if (userId == 1) {
    menu[7].child = [...baseMenu, ...User1]
    return menu
  }
  else {
    menu[7].child = baseMenu
    return menu
  }

}
export default {
  props: {
    curs: {
      type: String,
      defalut: '0-0'
    }
  },
  data() {
    return {
      slide: putSlide(Slide, this.$store.state.user.id),
      ruleNode: [],
      allNode: false
    }
  },
  created() {
  },
  methods: {
    setDateTime() {
      this.$emit('backhome', 'home')
      store.dispatch("updateWatermarks");
      this.$router.push({ name: 'home' })
    },
    cursQg(val) {
      if (val) {
        return val.split("-")
      }
    },
    getRuleNode() {
      if (this.$store.state.user) {
        let link_group = this.$store.state.user.link_group
        this.allNode = this.$store.state.user.link_group.filter((ele) => {
          return ele.user_group_id === 1
        }).length > 0  //是否有超级管理员权限
        if (!this.allNode) {
          let ruleNode = []
          link_group.forEach(ele => {
            ruleNode = ruleNode.concat(ele.group.view)
          });
          ruleNode = ruleNode.filter((ele, index) => {
            return ruleNode.indexOf(ele) === index;
          })
          this.ruleNode = ruleNode
        }
      }
    },
    FlinkTo(item) {
      const user = this.$store.state.user;
      if (user.id == 1) {
        this.$emit('setRoute', item)
        this.linkTo(item)
      } else {
        if (item.child) {
          const list = item.child.filter(ele => {
            return this.$common.AUTH(ele.key)
          })
          let Has = item.child
          if (this.$store.state.user.id != 1 && list.length == 0) {
            this.$message.error("暂无权限")
            return false;
          } else {
            this.$emit('setStatus', list)
          }
          store.dispatch("updateWatermarks");
          if (Has[0].link != this.$route.name) {
            this.$router.push({ name: Has[0].link })
          } else {
            this.$router.go(0)
          }
        } else {
          this.$emit('setParent', item)
          this.linkTo(item)
        }
      }
    },
    linkTo(j) {
      if (!this.$common.AUTH(j.key) && this.$store.state.user.id != 1 && j.other) {
        this.$message.error("暂无权限")
        return false;
      }
      store.dispatch("updateWatermarks");
      if (j.link != this.$route.name) {
        this.$router.push({ name: j.link })
      } else {
        this.$router.go(0)
      }
    },
    isShow(item) {
      if (this.allNode) {
        return true
      } else {
        return this.ruleNode.filter((ele) => {
          return ele.split('-')[0] === item.key
        }).length > 0
      }
    }
  }
}
</script>
<style lang="less" scoped>
.slide {
  display: flex;
  gap: 12px;
  padding-left: 30px;

  .home,
  .a {
    font-size: 17px !important;
    color: rgba(245, 244, 244, 0.8);
    transition-duration: 500ms;
    white-space: nowrap;
    position: relative;
    cursor: pointer;
    flex: 1;
    height: 57px;
    box-sizing: border-box;
    // gap: 5px;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      opacity: 0.8;
    }

    .childList {
      position: absolute;
      width: 96px;
      background: #fff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
      left: -8px;
      top: 32px;
      transition-duration: 500ms;
      display: none;

      a {
        display: block;
        line-height: 20px;
        font-size: 0.875rem;
        color: #333;
        text-align: center;
        transition-duration: 500ms;
        padding: 10px 0;

        &:hover {
          color: #1d8bfe;
        }

        &:nth-child(1) {
          padding-top: 14px;
        }

        &:nth-last-child(1) {
          padding-bottom: 14px;
        }
      }

      .cact {
        color: #1d8bfe;
      }
    }

    &:not(.act):hover {
      color: #f7f7f7;
      border-radius: 30px;

      span {
        opacity: 1;
      }

      .childList {
        display: block;
      }

      .Slider {
        position: absolute;
        bottom: 0px;
        width: 55px;
        height: 4px;
        transform: translateX(50%);
        right: 50%;
        background: #f7f7f7;
        transition-duration: 500ms;
      }
    }
  }

  .home {
    padding: 15px 20px;
  }

  .draplist {
    background: url("../../assets/img/drap.png") no-repeat right 49px;
    background-size: 10px auto;
    padding-right: 14px;
  }

  .acthome {
    background-color: #fff;
    color: #1d8bfe;
    font-weight: bold;
    border-radius: 30px;
    text-align: center;
    padding: 15px 20px;

    span {
      opacity: 1;
    }
  }

  .act {
    background-color: #fff;
    color: #1d8bfe;
    font-weight: bold;
    border-radius: 30px;
    text-align: center;

    span {
      opacity: 1;
    }

    /* 选中态强制取消鼠标悬浮效果 */
    pointer-events: none;
  }
}
</style>
